import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  TextField,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import themestyle from "../theme";
import { RequestCancleModelProps } from "../interfaces/requestCancel";

const RequestCancleModel: React.FC<RequestCancleModelProps> = ({
  open,
  onClose,
  className,
  onSend,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [reason, setReason] = React.useState("");
  React.useEffect(() => {
    if (open) {
      setReason("");
    }
  }, [open]);

  const handleSend = () => {
    if (onSend) {
      onSend(reason);
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "5px",
          p: isMobile ? 1 : 2,
          margin: isMobile ? 2 : 4,
        },
      }}
    >
      <DialogContent sx={{ py: isMobile ? 3 : 4, px: isMobile ? 2 : 3 }}>
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, mb: 2 }}>
          <ErrorOutlineIcon sx={{ color: themestyle.colors.error, fontSize: 28, mt: 0.5 }} />
          <Typography variant="h5" fontWeight={700} sx={{ color: "#111827", fontSize: isMobile ? "20px" : "24px" }}>
            Request Cancellation
          </Typography>
        </Box>

        <Typography
          sx={{
            color: "#4B5563",
            lineHeight: 1.5,
            mb: 4,
            fontSize: isMobile ? "13px" : "16px",
          }}
        >
          Requesting cancellation for <strong>{className || "this class"}</strong>. This request will be sent to the Admin for approval.
        </Typography>
        <Typography
          variant="caption"
          fontWeight={700}
          sx={{
            display: "block",
            color:themestyle.colors.black,
            mb: 1,
            letterSpacing: "0.05em",
            fontSize: "12px",
          }}
        >
          REASON FOR REQUEST
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          placeholder="e.g.Instructor emergency,Studio maintenance..."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          sx={{
            mb: 4,
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
              backgroundColor: "#F9FAFB",
              fontSize: isMobile ? "13px" : "14px",
              "& fieldset": { borderColor: "#E5E7EB" },
              "&:hover fieldset": { borderColor: "#D1D5DB" },
              "&.Mui-focused fieldset": { borderColor: themestyle.colors.error , borderWidth:"1px"},
            },
            "& .MuiInputBase-input::placeholder": {
              fontSize: isMobile ? "12px" : "13px",
              opacity: 1,
            },
          }}
        />

        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            fullWidth
            variant="outlined"
            onClick={onClose}
            sx={{
              py: isMobile ? 0.8 : 1.5,
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              color: "#4B5563",
              borderColor: "#E5E7EB",
              backgroundColor: "#F9FAFB",
              fontSize: isMobile ? "14px" : "16px",
              "&:hover": {
                borderColor: "#D1D5DB",
                backgroundColor: "#F3F4F6",
              },
            }}
          >
            Dismiss
          </Button>
          <Button
            fullWidth
            variant="contained"
            onClick={handleSend}
            disabled={!reason.trim()}
            sx={{
              py: isMobile ? 0.8 : 1.5,
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              backgroundColor: themestyle.colors.error,
              color: "white",
              fontSize: isMobile ? "14px" : "16px",
              boxShadow: "none",
              "&:hover": {
                backgroundColor:themestyle.colors.error,
                boxShadow: "none",
              },
            }}
          >
            Send Request
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
export default RequestCancleModel;